<dxc-dropdown
    label="Default Dropdown"
    size="medium"
    
    margin="small"
    (onSelectOption)="selected($event)"
  >
    <dxc-dropdown-option label="1" value="1"> </dxc-dropdown-option>
    <dxc-dropdown-option label="2"> </dxc-dropdown-option>
    <dxc-dropdown-option label="3"> </dxc-dropdown-option>
    <dxc-dropdown-option label="4" value="1"> </dxc-dropdown-option>
    <dxc-dropdown-option label="5"> </dxc-dropdown-option>
    <dxc-dropdown-option label="6"> </dxc-dropdown-option>
    <dxc-dropdown-option label="7" value="1"> </dxc-dropdown-option>
    <dxc-dropdown-option label="8"> </dxc-dropdown-option>
    <dxc-dropdown-option label="9"> </dxc-dropdown-option>
    <dxc-dropdown-option label="10" value="1"> </dxc-dropdown-option>
    <dxc-dropdown-option label="11"> </dxc-dropdown-option>
    <dxc-dropdown-option label="12"> </dxc-dropdown-option>
  </dxc-dropdown>